import React from 'react';
import {Table} from 'reactstrap';
import { getMembershipNotes,SaveMembershipNotes} from '../../../../../Redux/Actions/Admin/ManageMembershipActions';
import { auth } from '../../../../../services';
import { connect } from 'react-redux';
import IsLoading from '../../../../Shared/Loading/IsLoading';
import { toastr,RemoveEmailMessage } from '../../../../../Redux/Actions/CommonActions';
import { Alert } from 'reactstrap';
import { withRouter } from 'react-router';
import { provideIntlService } from '@progress/kendo-react-intl';

import '../../../../PublicView/Pages/MyMemberships/AuthorizedMembers/AuthorizedMembers.scss';

class MembershipNotesForm extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			membershipId:this.props.dataItem.membershipId || 0,
            membershipNotesId: 0,
            notes: "",
            AspNetUserId:""
		};
	}


	componentDidMount() {
        console.log(this.state, "state in members Notes")
        this.setState({
			ApplicationUserId:auth.getAuthUserId()
		})
        this.props.getMembershipNotes(this.state.membershipId);
	}
	componentDidUpdate(prevProps, prevState) {
        if (prevProps.membershipNotes !== this.props.membershipNotes) {
            this.setState({
                ...this.props.membershipNotes
            })
        }
    }
   
    handleSubmit = (event) => {
		event.preventDefault();
        console.log(this.state, "state in member Notes Submit")
        this.props.SaveMembershipNotes(this.state);
    };
    
    onDialogInputChange = (event) => {
		let target = event.target;
		this.setState({
			notes: target.value
		});
    };
	
	render() {
		if (this.props.getting)
			return (
				<div>
					<IsLoading />
				</div>
			);
		return (
			<React.Fragment>
			{this.props.common.visible ? (
				<Alert
					color={this.props.common.color}
					isOpen={this.props.common.visible}
                    style={{ position: 'fixed', width: '100%', maxHeight: '50px', zIndex: '1', top: '110px' }}
				>
					{this.props.common.message}
				</Alert>
            ) : null}
            <form className="user-form membership-form" onSubmit={this.handleSubmit}>
                        <div className="form-group col-md-12">
                            <h2 className="callout">Enter <span className="highlight">Membership Notes</span></h2>
                        </div>
                            <div className="form-group col-md-12 col-lg-7">
                            <label htmlFor="notes">Notes</label>
                                <textarea
                                    required={true}
                                    type="text"
                                    name="notes"
                                    id="descrnotesiption"
                                    className="k-textarea"
                                    value={this.state.notes}
                                    onChange={this.onDialogInputChange}
						        ></textarea>
                            </div>
                            <div className="form-group col-md-12">
                                
                                <button type="submit" className="admin-k-button">
                                    <i className="fas fa-save"></i>
                                    <span>SAVE</span>
                                </button>
                            </div>
                    </form>
					<div className="table-responsive">
						<h1 className="pt-3 pb-3">Previous Notes</h1>
							<Table hover className="edit-account-form card">
								<thead>
									<tr>
										<th>Notes </th>
										<th>Created By</th>
										<th>Created Date</th>
										<th></th>
									</tr>
								</thead>
								<tbody>
								{this.props.membershipNotes.length >0?this.props.membershipNotes.map((item,i) => 
									<tr>
                                      <td>{item.notes}</td>
                                      <td>{item.applicationUser.userName}</td>
                                      <td>{provideIntlService(this).formatDate(new Date(item.createDate), 'MM/d/y')}</td>
									</tr>
								):""}
								</tbody>
							</Table>
						</div>
						<button className="admin-k-button cancel-btn"  onClick={this.props.cancel}>
                                    <i className="fas fa-times"></i>
                                    <span>CANCEL</span>
                        </button>
			</React.Fragment>
		);
	}
}

function mapStateToProps(state) {
	return {
		membershipNotes: state.adminMembership.membershipNotes,
		common: state.common
	};
}

export default withRouter(connect(mapStateToProps, {
	getMembershipNotes,SaveMembershipNotes
})(MembershipNotesForm));
